import React from 'react'
import ConfettiVideo from 'assets/confetti/confetti-4.mp4'
import { ConfettiStyles } from 'styles/components/atoms/Confetti'
import HelperPlatform from 'utils/helper-platform'
import ThemedVideo from 'components/atoms/ThemedVideo'

const Confetti = () => {
	
	if( HelperPlatform.isWeb() ) {
		return null;
	}
	
	return (
		<ThemedVideo
			style={ ConfettiStyles.video }
			source={ ConfettiVideo }
		/>
	)
}

export default Confetti
